export const validTypes = ["emoji"];
